import { createStore } from 'vuex'
// import {MklUserInfo} from "@/publiclibs/info"

export default createStore({
  state: {
    userToken: localStorage.MklUserToken,
    mklUserInfo: {},
    MklFruit: {},
    shopcartnum:0
  },
  getters: {
    userToken: state => state.userToken,
    MklFruit: state => state.MklFruit,
    mklUserInfo: state => state.mklUserInfo
  },
  mutations: {
    setUserToken(state, payload) {
        state.userToken = payload
        localStorage.MklUserToken = payload
    },
    
    setshopcartnum(state, payload) {
      state.shopcartnum = payload
  },
    setMklUserInfo(state, payload) {
        state.mklUserInfo = payload
        // state.shopcartnum = payload.cart
    },
    setMklFruit(state, payload) {
        state.MklFruit = payload.data
    }
  }, 
  actions: {
      setUser({commit}, payload) {
          commit('setUserToken', payload)
      },
  },
  modules: {
  }
})
